<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="checkModuleAccess2(constAccessType.add)">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["MW"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="close()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content dpt-wtd">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TMW"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_tm"
                                                        :placeholder="this.utilGetDDLanguage('MTA.TMW')"
                                                        v-model="obj_aw['TM']"
                                                        :clearable="false"
                                                        openDirection="below"
                                                        @input="TransTypeChange" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol :col="getUserInfo.HSA? 4: 6" v-if="getUserInfo.AT !== 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        v-model="obj_aw['AGIT']"
                                                        @input="AgentGroupChange"
                                                        value-format="object"
                                                        openDirection="below"
                                                        ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                        <CCol :col="getUserInfo.HSA && getUserInfo.AT !== 4? 4: 6" v-if="getUserInfo.HSA">
                                            <label class="col-form-label-sm">{{this.getLanguage['GL']['SAGT']}}  :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :key="rtSubBrand"
                                                        :defaultOptions="dd_DefaultSubBrand"
                                                        :load-options="loadSubBrandOptions"
                                                        :cacheOptions="false"
                                                        :options="dd_subagentgroup"
                                                        :clearable="false"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                        v-model="obj_aw['SAGAGI']"
                                                        @input="SubAgentGroupChange"
                                                        :disabled="!obj_aw['AGIT']"
                                                        openDirection="below" />
                                            <!--<span class="ErrMsg">{{ ValidationErrMsg('MI','MUN') }}</span>-->
                                        </CCol>
                                        <CCol :col="getUserInfo.HSA && getUserInfo.AT !== 4? 4: 6">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}}<span v-if="obj_aw['TM']==0 || (obj_aw['TM']==1 && getUserInfo.AT == 4)"><span class="required" /></span> :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :cacheOptions="false"
                                                        :load-options="loadMemberOptions"
                                                        :options="dd_mem"
                                                        :clearable="false"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('MEM.U')"
                                                        v-model="obj_aw['MI']"
                                                        @input="MemberChange"
                                                        :disabled="(obj_aw['TM']!=0 && getUserInfo.AT < 4) || (obj_aw['TM']!=1 && getUserInfo.AT == 4)"
                                                        openDirection="below"
                                                        ref="MI" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MI','MUN') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="7" v-if="getUserInfo.AT < 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MB"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_membankname"
                                                        :clearable="false"
                                                        v-model="mamBankAcc"
                                                        :placeholder="this.utilGetDDLanguage('MTA.MB')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        openDirection="below"
                                                        :disabled="obj_aw['TM']!=0" />

                                        </CCol>

                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput :prepend="CurrencySymbol" size="sm" :value="ThousandSeparator(obj_aw.TA, getThousandCurrency ? 3 : 2)" @change="v => obj_aw.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="TA" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TA','TA') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="getUserInfo.AT < 4">
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TID"]}} :</label>
                                            <CInput size="sm" :value="obj_aw.TID" @change="v => obj_aw.TID = v" :disabled="obj_aw['TM']!=0" />
                                        </CCol>
                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RURL"]}} :</label>
                                            <div style="display:block;">
                                                <input type="file" name="pic" accept="image/*, .pdf" @change="onFileSelected" :disabled="obj_aw['TM']!=0" style="overflow: hidden;" />
                                            </div>
                                        </CCol>

                                    </CRow>
                                    <CRow v-if="getUserInfo.AT < 4">
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage['MTA']['CAD']}}<span v-if="obj_aw['TM']==0 && !bool_OCAD"><span class="required" /></span> :</label> <CButton :disabled="obj_aw['TM']!=0" size="sm" color="outline-info" style="float: right;" @click="addBank()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, CurrencySymbol ) }}</span>
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width:0%;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width:0%;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th style="width:35%;">{{this.getLanguage['MTA']['BKN']}}</th>
                                                            <th style="width:40%;">{{this.getLanguage['MTA']['BAN']}}</th>
                                                            <th style="width:25%;" class="tableCtnRight">{{this.getLanguage['MTA']['TA']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_aw.BankList == 0 || !obj_aw.BankList">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_aw.BankList">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removeBank(index)'></i> <!--here Remove -->
                                                                <i class="cil-color-border" @click='editBank(data,index)'></i> <!--here Edit -->
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{data.BN}}</td>
                                                        <td>{{data.BA}}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.TA, 2, CurrencySymbol) }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                            <span class="ErrMsg">{{ ErrBAAmount }}</span>
                                        </CCol>
                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                            <textarea vertical="" rows="7" class="form-control form-control-sm" :value="obj_aw.R" @change="TextValueChange('R',$event)" />
                                        </CCol>
                                    </CRow>
                                </div>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton v-shortkey="['enter']" @shortkey="saveWithdraw()" :disabled="sensBtn" color="outline-success" size="sm" @click="saveWithdraw()">
                                        {{this.getLanguage['MTA']['MW']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>

                </div>
            </transition>
        </div>

        <div v-if="checkModuleAccess2(constAccessType.add) && bool_isABA">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:50%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["MTA"]["CAD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddBank()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BKN"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bank"
                                                    v-model="obj_bank['BNI']"
                                                    :noOptionsText="this.getLanguage['GL']['NOA']"
                                                    :placeholder="this.utilGetDDLanguage('MTA.BKN')"
                                                    @input="BankNameChange($event, false)"
                                                    :clearable="false"
                                                    ref="BNI" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BNI','BKN') }}</span>
                                    </CCol>
                                    <CCol col="6" v-if="bool_showTDTL">
                                        <label class="col-form-label-sm">{{this.getLanguage["BANK"]["TDTL"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <div role="group" class="form-group">
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">{{CurrencySymbol}}</span>
                                                </div>
                                                <span class="form-control" v-html="str_TotalDailyTransactionLimit"></span>
                                            </div>
                                        </div>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BAN"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bankacc"
                                                    :noOptionsText="this.getLanguage['GL']['NOA']"
                                                    :placeholder="this.utilGetDDLanguage('MTA.BAN')"
                                                    v-model="obj_bank['BAI']"
                                                    :clearable="false"
                                                    @input="BankAccountChange($event)"
                                                    ref="BAI" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BAI','BAN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, CurrencySymbol ) }}</span>
                                        <CInput :prepend="CurrencySymbol"
                                                size="sm"
                                                :readonly="obj_bank.IAW"
                                                :value="ThousandSeparator(obj_bank.TA, getThousandCurrency ? 3 : 2)"
                                                @change="v => obj_bank.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                ref="TA" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('TA','TA') }}</span>
                                        <span class="ErrMsg" v-if="IsAllowAutoWithdraw && obj_convertedCurrency.FDA"> {{ formatNumber(obj_aw.TA, 2, CurrencySymbol)  }} / {{ obj_convertedCurrency.TER }} = {{ obj_convertedCurrency.FDAD }} </span>
                                    </CCol>
                                </CRow>
                                <CRow v-if="IsAllowAutoWithdraw">
                                    <CCol col="6">
                                        <label class="switch">
                                            <input type="checkbox" v-model="obj_bank.IAW" @change="toggleAllowAutoWithdraw">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["IAW"]}}</label>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBank()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf, decimal, minValue } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import axios from "axios";
    import { constAccessType, loadingFullScreen, constADBBankSupportChannels, constADBBankAccountBalanceLimit } from '@/modules/Constant.js';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                str_bankacc_used_agi: 0,
                str_member_used_agi: 0,
                selectedFile: null,
                bool_CV: false, // Check Validation
                bool_bankCV: false, // Check Bank Validation
                bool_isABA: false, // Add Bank Modal Visible
                bool_fullLoading: false, //Loading Visible
                sensBtn: true,
                bool_fullScreen: loadingFullScreen, //Full Screen
                obj_aw:
                {
                    AGI: null,
                    MI: null,
                    TM: 0,
                    TID: "",
                    BAI: null,
                    BNI: null,
                    MB: "",
                    MBA: "",
                    MBN: "",
                    PMT: null,
                    R: "",
                    RS: 2,
                    IMA: 1,
                    TT: 2,
                    PM: null,
                    RURL: "",
                    AC: 2,
                    DI: 0,
                    TA: "",
                    IAW: 0,
                    FCS: null,
                    ER: 1,
                    TCS: null,
                    TER: 1,
                }, // add withdraw
                obj_bankacc: {},
                obj_convertedCurrency: {},
                mamBankAcc: null,
                dd_agentgroup: [],//agent group option
                dd_subagentgroup: [],
                dd_membankname: [],
                dd_bank: [],
                constAccessType: constAccessType,
                dd_bankacc: [],
                dd_mem: [],
                dd_tm: [], // transaction type
                obj_bank: {
                    BN: null,
                    BNI: null,
                    BAI: null,
                    BA: null,
                    TA: null,
                    IAW: null,
                },
                ErrBAAmount: "",
                CurrencySymbol: "",
                editBankIndex: -1,
                dd_DefaultSubBrand: [],
                rtSubBrand: 0,
                bool_OCAD: true,  // optional company account detail
                bool_showTDTL: false,
                str_TotalDailyTransactionLimit: 0,
                hasTransLoading: false,
                IsAllowAutoWithdraw: false,
            }
        },
        validations: {
            obj_bank: {
                BNI: { required },
                BAI: { required },
                TA: { required },
            },
            obj_aw: {
                TM: { required },
                MI: {
                    required: requiredIf(function (vm) {
                        return vm.TM == 0 || (vm.TM == 1 && this.getUserInfo.AT == 4);
                    }),
                },
                AGIT: {
                    required: requiredIf(function (vm) {
                        return vm.TM == 0 || vm.TM == 1;
                    }),
                },
                TA: {
                    required: requiredIf(function (vm) {
                        return vm.TM == 0 || vm.TM == 1;
                    }),
                    decimal,
                    minValueValue: minValue(0)
                }
            }
        },
        created() {
            this.$parent.showSubMenu = 'W';
            this.$parent.showActiveMenu = 'W.MW';
            this.getAgentGroup();
            this.getTMList();
            this.setThousandCurrency(false);
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

            if (this.getUserInfo.AT == 4) {
                this.obj_aw.TM = 1;
                this.obj_aw['AGIT'] = true;
                this.getSubAgentGroup(0, true);
                this.sensBtn = (this.isSENS == 0) ? false : true;
            }
            else {
                this.obj_aw.TM = 0;
                this.dd_DefaultSubBrand = [];
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_aw.R = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MW', 'W', type);
            },
            close() {
                if (!this.checkModuleAccess('WDU', 'W', this.constAccessType.view)) {
                    this.$router.push("/M/ML");
                }
                else {
                    this.$router.push("/W/WDU");
                }
            },
            closeAddBank() {
                this.bool_isABA = !this.bool_isABA;
                this.bool_bankCV = false;
                this.obj_bank = {
                    BN: null,
                    BNI: null,
                    BAI: null,
                    BA: null,
                    TA: null,
                    IAW: null,
                }
                this.dd_bankacc = [];
                this.editBankIndex = -1;
                this.bool_showTDTL = false;
            },
            addBank() {
                this.obj_bank = {
                    BN: null,
                    BNI: null,
                    BAI: null,
                    BA: null,
                    TA: null,
                    IAW: null,
                }
                this.bool_isABA = true;
                this.editBankIndex = -1;
            },
            saveBank() {
                if (this.obj_bank.TA == 0) {
                    this.obj_bank.TA = null;
                }
                this.bool_bankCV = true;
                this.$v.obj_bank.$touch();
                if (!this.$v.obj_bank.$error) {
                    var exist = false;
                    if (!this.obj_aw.BankList) {
                        this.obj_aw.BankList = [];
                    }
                    for (var pt of this.dd_bank) {
                        if (pt.id == this.obj_bank['BNI']) {
                            this.obj_bank['BN'] = pt.label;
                        }
                    }
                    for (var pt of this.dd_bankacc) {
                        if (pt.id == this.obj_bank['BAI']) {
                            this.obj_bank['BA'] = pt.label;
                        }
                    }

                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        if (this.obj_aw.BankList[i].BAI == this.obj_bank.BAI && this.editBankIndex != i) {
                            exist = true;
                            break;
                        }
                    }
                    if (!exist && this.editBankIndex != -1) {
                        this.obj_aw.BankList[this.editBankIndex] = this.obj_bank;
                        this.bool_isABA = false;
                        this.bool_bankCV = false;
                        this.obj_bank = {};
                        this.dd_bankacc = [];
                        this.editBankIndex = -1;
                    }
                    else if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["MTA"]["BAN"]), 1000);
                    }
                    else {
                        this.obj_aw.BankList.push(this.obj_bank);
                        this.bool_isABA = false;
                        this.bool_bankCV = false;
                        this.obj_bank = {};
                        this.dd_bankacc = [];
                        this.editBankIndex = -1;
                    }
                } else {
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_bank"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeBank(index) {
                this.$delete(this.obj_aw.BankList, index);
                this.$forceUpdate();
            },
            editBank(data, index) {
                this.bool_bankCV = false;
                this.obj_bank = Object.assign({}, data);
                this.BankNameChange(this.obj_bank.BNI, true);
                this.bool_isABA = true;
                this.editBankIndex = index;
            },
            CalculateRemainAmount(TA, CS) {
                if (this.obj_aw.BankList != null) {
                    var amount = 0;
                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        amount += parseFloat(this.obj_aw.BankList[i].TA);
                    }
                    TA -= amount;

                    return this.formatNumber(TA, 2, CS);
                }
                else {
                    return this.formatNumber(TA, 2, CS);
                }
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event, 5, [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".pdf"]);
            },
            getTMList() {
                if (this.getUserInfo.AT == 4) {
                    this.dd_tm = [{ id: '1', label: this.getLanguage['MTA']['TM1'] }];
                }
                else {
                    this.dd_tm = [{ id: '0', label: this.getLanguage['MTA']['TM0'] }];
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup[0].children == undefined) {
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                if ((at == 3 || at == 4) && that.dd_agentgroup.length < 2) {
                                    that.obj_aw.AGIT = that.dd_agentgroup[0];
                                    that.AgentGroupChange();
                                }
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            TransTypeChange(value) {
                this.obj_aw.MI = null;
                this.obj_aw.TID = "";
                this.obj_aw.BAI = null;
                this.obj_aw.BNI = null;
                this.obj_aw.MB = "";
                this.obj_aw.MBA = "";
                this.obj_aw.MBN = "";
                this.obj_aw.PMT = null;
                this.obj_aw.R = "";
            },
            BankNameChange(value, isEdit = false) {
                if (!isEdit) {
                    this.obj_aw['BAI'] = null;
                }
                this.dd_bankacc = [];

                if (value != undefined) {
                    var that = this;
                    this.getDataApi(`/api/dd/bankacc/` + value + "/" + this.str_bankacc_used_agi + "/2/0" + this.CurrencySymbol,
                        function (d, s) {
                            if (s) {
                                that.dd_bankacc = d.dropdownlist;
                            }
                        });
                }
                this.bool_showTDTL = false;
                this.obj_bank['BAI'] = null;
                this.obj_bankacc = null;
                this.resetAutoWithdrawal();
            },
            BankAccountChange(value) {
                if (value) {
                    const bankAcc = this.dd_bankacc.find(f => f.id == value);
                    if (bankAcc) {
                        var that = this;
                        this.getDataApi(`/api/bankacc/ddwa/` + value,
                            function (d, s) {
                                if (s) {
                                    that.bool_showTDTL = bankAcc.TD > 0;
                                    if (that.bool_showTDTL) {
                                        if (bankAcc.TUD >= bankAcc.TD)
                                            that.str_TotalDailyTransactionLimit = "<span class='text-danger'>" + that.ThousandSeparator(bankAcc.TUD, that.getThousandCurrency ? 3 : 2) + "</span> / " + that.ThousandSeparator(bankAcc.TD, that.getThousandCurrency ? 3 : 2);
                                        else
                                            that.str_TotalDailyTransactionLimit = that.ThousandSeparator(bankAcc.TUD, that.getThousandCurrency ? 3 : 2) + " / " + that.ThousandSeparator(bankAcc.TD, that.getThousandCurrency ? 3 : 2);
                                    }
                                }
                            });
                        this.obj_bankacc = bankAcc
                        this.resetAutoWithdrawal();
                        this.checkIsAllowAutoWithdraw();
                    }
                }
            },
            MemberChange(value) {
                var that = this;
                this.dd_membankname = [];
                var memberid = value;
                this.getDataApi(`/api/memtrans/gcs/` + value,
                    function (d, s) {
                        if (s) {
                            that.CurrencySymbol = d;
                            that.CurrencyChange(d);
                            that.getBankDD(d);
                        }
                    });
                this.getDataApi(`/api/dd/memberbankname/` + memberid,
                    function (d, s) {
                        if (s) {
                            that.dd_membankname = d.dropdownlist;
                        }
                    });
            },
            AgentGroupChange(value) {

                if (value != undefined) {

                    this.obj_aw['MI'] = null;
                    this.obj_aw['BAI'] = null;
                    this.obj_aw['BNI'] = null;
                    this.obj_aw['SAGAGI'] = null;

                    this.dd_mem = [];
                    this.dd_bank = [];
                    this.dd_bankacc = [];

                    if (this.obj_aw['AGIT']) {
                        var agiSelectedValue = this.obj_aw['AGIT'].id;
                        var agentList = agiSelectedValue.split("-");
                        if (agentList[0] == "4") {
                            this.str_bankacc_used_agi = this.obj_aw['AGIT'].extra;
                            this.str_member_used_agi = agentList[agentList.length - 1];
                        }
                        else {
                            this.str_bankacc_used_agi = agentList[agentList.length - 1];
                            this.str_member_used_agi = this.str_bankacc_used_agi;
                        }
                        this.sensBtn = ((this.isSENS == 1 && this.str_bankacc_used_agi != this.curAGI) ? true : false);
                        this.OptionalCompanyBankDetail(this.str_bankacc_used_agi);
                    }
                }

            },
            SubAgentGroupChange() {
                this.obj_aw['MI'] = null;
                this.obj_aw['BAI'] = null;
                this.obj_aw['BNI'] = null;

                this.dd_mem = [];
                this.dd_bank = [];
                this.dd_bankacc = [];
                this.dd_promo = [];

                if (this.obj_aw['AGIT'] && this.obj_aw['SAGAGI']) {
                    var agiSelectedValue = this.obj_aw['AGIT'].id;
                    var agentList = agiSelectedValue.split("-");
                    if (agentList[0] == "4") {
                        this.str_bankacc_used_agi = this.obj_aw['AGIT'].extra;
                        this.str_member_used_agi = this.obj_aw['SAGAGI'];
                    }
                    else {
                        this.str_bankacc_used_agi = agentList[agentList.length - 1];
                        this.str_member_used_agi = this.obj_aw['SAGAGI'];
                    }
                }

            },
            getSubAgentGroup(value, isFirstLoad = false) {
                var that = this;
                this.getDataApi(`/api/dd/subbrand/0/0/${value}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);

                            if (isFirstLoad) {
                                that.obj_aw['SAGAGI'] = that.dd_DefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                            }
                        }
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    this.dd_mem = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.str_member_used_agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_mem = d.dropdownlist;
                            }
                            else {
                                that.dd_mem = [];
                            }
                            callback(null, that.dd_mem);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.str_member_used_agi > 0) {
                    parentAGI = this.str_member_used_agi;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            getBankDD(cs) {
                var that = this;
                //// withdrawal with auto deposit bank return
                this.getDataApi(`/api/dd/bank/` + this.str_bankacc_used_agi + "/4/0/" + cs,
                    function (d, s) {
                        if (s) {
                            that.dd_bank = d.dropdownlist;
                        }
                    });
            },
            ValidationBankErrMsg(value, langKey = "") {
                if (this.bool_bankCV) {
                    var validateObj = this.$v.obj_bank[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_aw[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage["MTA"][langKey]);
                    }
                }

            },
            saveWithdraw() {
                this.bool_CV = true;
                this.ErrBAAmount = "";
                this.bool_fullLoading = true;
                this.obj_aw['MB'] = "";
                this.obj_aw['MBA'] = "";
                this.obj_aw['MBN'] = "";
                for (var i = 0; i < this.dd_membankname.length; i++) {
                    if (this.mamBankAcc == this.dd_membankname[i].id) {
                        var accountData = this.dd_membankname[i].label.split('-');
                        this.obj_aw['MB'] = accountData[0];
                        this.obj_aw['MBA'] = accountData[1];
                        this.obj_aw['MBN'] = accountData[2];
                    }
                }

                var transAmount = 0;
                if (this.obj_aw.BankList) {
                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        transAmount += parseFloat(this.obj_aw.BankList[i].TA);
                        if (Boolean(this.obj_aw.BankList[i].IAW) == true) {
                            this.obj_aw.IAW = 1;
                        }
                    }
                    if (this.obj_aw.BankList.length > 1) {
                        this.obj_aw.IAW = 0;
                    }
                } else if (this.bool_OCAD) {
                    transAmount = parseFloat(this.obj_aw.TA);
                }

                if (this.hasTransLoading) return; 
                
                this.$v.obj_aw.$touch();
                if (!this.$v.obj_aw.$error) {
                    
                    if (!this.obj_aw.BankList && this.obj_aw.TM == 0 && !this.bool_OCAD) {
                        this.ErrBAAmount = String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"]["CAD"]);
                        this.bool_fullLoading = false;
                    }
                    else if (transAmount.toFixed(this.getThousandCurrency ? 3 : 2) != parseFloat(this.obj_aw.TA).toFixed(this.getThousandCurrency ? 3 : 2) && this.obj_aw.TM == 0) {
                        this.ErrBAAmount = this.getLanguage["MTA"]["ErrAmount"];
                        this.bool_fullLoading = false;
                    }
                    else if (this.obj_aw.IAW == 1 && this.obj_bankacc && constADBBankAccountBalanceLimit > this.obj_bankacc.extra) {
                        this.ErrBAAmount = this.getLanguage["MTA"]["BALISF"];
                        this.bool_fullLoading = false;
                    }
                    else {
                        //CASH WITHDRAW
                        if (this.obj_aw['TM'] == 0) {
                            this.obj_aw['PM'] = 1;
                            this.obj_aw['WSRT'] = "::[MTA][WST]::";   //this.getLanguage["MTA"]["WST"];
                            this.obj_aw['WSRM'] = "::[MTA][WSM]::";   //this.getLanguage["MTA"]["WSM"];
                        }

                        //CREDIT WITHDRAW
                        if (this.obj_aw['TM'] == 1) {
                            this.obj_aw['PM'] = 3;
                            this.obj_aw['WSRT'] = "::[MTA][WST]::";
                            this.obj_aw['WSRM'] = "::[MTA][WSM]::";
                            this.obj_aw['TT'] = "2";
                        }

                        if (this.obj_aw['AGIT'] != null) {
                            var selectedAGI = 0;
                            var agiSelectedValue = this.obj_aw['AGIT'].id;
                            var agentList = agiSelectedValue.split("-");
                            if (agentList[0] == "4") {
                                selectedAGI = this.obj_aw['AGIT'].extra;
                            }
                            else {
                                selectedAGI = agentList[agentList.length - 1];
                            }

                            this.obj_aw.AGI = selectedAGI;
                        }

                        this.obj_aw["RURL"] = this.selectedFile;
                        this.bool_fullLoading = false;
                        this.$fire({
                            title: this.getLanguage["MTA"]["CA"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            keydownListenerCapture: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                var that = this;
                                this.bool_fullLoading = true;
                                this.bool_fullScreen = true;
                                this.hasTransLoading = true;
                                this.postDataApiWithAttach(`/api/memtrans/ap`, this.obj_aw,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        that.bool_fullScreen = false;
                                        that.hasTransLoading = false;
                                        if (s) {
                                            if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 9001) {
                                                that.$fire({
                                                    title: that.getLanguage["MTA"]["CA"],
                                                    html: that.getLanguage["MTA"]["CIITO"],
                                                    width: '30em',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Ok',
                                                    cancelButtonText: 'Cancel',
                                                    reverseButtons: true,
                                                    keydownListenerCapture: true,
                                                    customClass: {
                                                        title: 'afb-alert-title',
                                                        content: 'afb-alert-content',
                                                        actions: 'afb-alert-action'
                                                    }
                                                }).then((result) => {
                                                    if (result.value == true) {
                                                        that.bool_fullLoading = true;
                                                        that.obj_aw['IITO'] = 1;
                                                        that.postDataApi(`/api/memtrans/ap`, that.obj_aw,
                                                            function (d, s) {
                                                                that.bool_fullLoading = false;
                                                                if (s) {
                                                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                                                    that.bool_CV = false;
                                                                    that.ErrBAAmount = "";

                                                                    var tempAGIT = that.obj_aw.AGIT;
                                                                    var tempAGI = that.obj_aw.AGI;
                                                                    that.obj_aw =
                                                                    {
                                                                        AGIT: tempAGIT,
                                                                        AGI: tempAGI,
                                                                        MI: null,
                                                                        TM: 0,
                                                                        TID: "",
                                                                        BAI: null,
                                                                        BNI: null,
                                                                        MB: "",
                                                                        MBA: "",
                                                                        MBN: "",
                                                                        PMT: null,
                                                                        R: "",
                                                                        RS: 2,
                                                                        IMA: 1,
                                                                        TT: 2,
                                                                        PM: null,
                                                                        RURL: "",
                                                                        AC: 2,
                                                                        TA: "",
                                                                    };
                                                                    // that.$router.push("/W/WDU");
                                                                }
                                                            });
                                                    }
                                                });
                                            }
                                            else {
                                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                                that.bool_CV = false;
                                                that.ErrBAAmount = "";
                                                that.obj_aw =
                                                {
                                                    AGI: null,
                                                    MI: null,
                                                    TM: 0,
                                                    TID: "",
                                                    BAI: null,
                                                    BNI: null,
                                                    MB: "",
                                                    MBA: "",
                                                    MBN: "",
                                                    PMT: null,
                                                    R: "",
                                                    RS: 2,
                                                    IMA: 1,
                                                    TT: 2,
                                                    PM: null,
                                                    RURL: "",
                                                    AC: 2,
                                                    TA: "",
                                                };
                                                that.close();
                                            }
                                        }
                                    });
                            }
                            else {
                                this.bool_fullLoading = false;
                                this.bool_fullScreen = false;
                                this.hasTransLoading = false;
                            }
                        });
                    }
                } else {
                    this.bool_fullLoading = false;
                    this.hasTransLoading = false; 
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_aw"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            OptionalCompanyBankDetail(agi) {
                var that = this;
                this.getDataApi(`/api/memtrans/reqcad/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.bool_OCAD = d;
                        }
                    });
            },
            getBankById(id) {
                let index = -1;
                if (!this.dd_bank || this.dd_bank.length == 0) {
                    return null;
                }

                for (let i = 0; i < this.dd_bank.length; i++) {
                    if (this.dd_bank[i].id == id) {
                        index = i;
                        break;
                    }
                }

                if (index != -1) {
                    return this.dd_bank[index];
                }

                return null
            },
            getBankAccById(id) {
                let index = -1;
                if (!this.dd_bankacc || this.dd_bankacc.length == 0) {
                    return null;
                }

                for (let i = 0; i < this.dd_bankacc.length; i++) {
                    if (this.dd_bankacc[i].id == id) {
                        index = i;
                        break;
                    }
                }

                if (index != -1) {
                    return this.dd_bankacc[index];
                }

                return null
            },
            toggleAllowAutoWithdraw() {
                if (Boolean(this.obj_bank.IAW) == true) {
                    const remainAmt = this.obj_aw.TA
                    let withdrawAmt = remainAmt
                    // convert to other currency[actual withdraw amt]
                    if (this.obj_bankacc.FCS && this.obj_bankacc.ER && this.obj_bankacc.TCS && this.obj_bankacc.TER) {
                        if (this.obj_bankacc.FCS != this.obj_bankacc.CS) {
                            withdrawAmt = parseFloat(this.obj_aw.TA.toString()) / parseFloat(this.obj_bankacc.TER.toString())
                            withdrawAmt = Math.floor(withdrawAmt)
                        }

                        let formattedNumber = this.formatNumber(withdrawAmt, 2, this.obj_bankacc.FCS).split(" ");
                        let thousandNumber = this.ThousandSeparator(withdrawAmt, 2)

                        //handle display UI
                        this.obj_convertedCurrency.TER = this.obj_bankacc.TER
                        this.obj_convertedCurrency.FDA = thousandNumber
                        this.obj_convertedCurrency.FDAD = formattedNumber[0] + " " + thousandNumber

                        //handle payload for approve withdrawal
                        this.obj_aw.FCS = this.obj_bankacc.FCS
                        this.obj_aw.ER = this.obj_bankacc.ER
                        this.obj_aw.TCS = this.obj_bankacc.TCS
                        this.obj_aw.TER = this.obj_bankacc.TER
                        this.obj_aw.FDA = withdrawAmt
                    }

                    this.obj_bank.TA = remainAmt
                    return
                }
                this.resetAutoWithdrawal(true);
            },
            resetAutoWithdrawal(fromToggle=false) {
                if (!fromToggle) {
                    this.IsAllowAutoWithdraw = false;
                }
                this.obj_aw.IAW = false;
                this.obj_bank.IAW = false;
                this.obj_bank.TA = null;
                this.obj_convertedCurrency = {}

                const FromKeys = ['FCS', 'ER', 'FDA']
                for (var key in this.obj_aw) {
                    if (this.obj_aw.hasOwnProperty(key) && FromKeys.indexOf(key) >= 0) {
                        delete this.obj_aw[key]
                    }
                }
            },
            checkIsAllowAutoWithdraw() {
                if (this.dd_bank && this.dd_bank.length == 0) {
                    return;
                }

                const bank = this.getBankById(this.obj_bank['BNI'] || 0);
                if (!bank) {
                    return;
                }

                const bankCode = bank.label2;
                const supportChannels = constADBBankSupportChannels[bankCode];
                if (!supportChannels) {
                    return;
                }

                let MB = ""
                for (var i = 0; i < this.dd_membankname.length; i++) {
                    if (this.mamBankAcc == this.dd_membankname[i].id) {
                        var accountData = this.dd_membankname[i].label.split('-');
                        MB = accountData[0];
                    }
                }

                if (supportChannels.indexOf(MB.toUpperCase()) == -1) {
                    return;
                }
                
                const acc = this.getBankAccById(this.obj_bank['BAI'] || 0);
                const isAllow = acc ? Boolean(acc.EAW) : false;
                this.IsAllowAutoWithdraw = isAllow
            },
        }

    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Withdraw/ManualWithdraw.vue